export default __webpack_public_path__ + "static/media/step_I_EN.9be60764.png";